import { useMediaQuery } from "./index";

const useScreenSizes = (): "sm" | "md" | "lg" => {
  const isSm = useMediaQuery("(max-width: 567px)");
  const isMd = useMediaQuery("(min-width: 568px) and (max-width: 1119px)");

  return isSm ? "sm" : isMd ? "md" : "lg";
};

export default useScreenSizes;
